import { useState } from "react";
import RangeSlider from 'react-bootstrap-range-slider'
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css'
import { Explorer } from "../../Explorer";



type Props = {
  uuid:any
}

export const StrokeWidth: React.FC<Props> = ({uuid}) => {


  const [sizeBorder, setSizeBorder] = useState(1)

  function onChange(size){
    Explorer.changeStyle(uuid, 'line-width', parseInt(size))
  }
  return (
    <>
      <div className='item-config'>
        <div className='item-config-align'>
          <div   data-bs-toggle='collapse'
              data-bs-target={`#collapseExample_${uuid}_strokwidith`}
              aria-expanded='false'
              aria-controls={`collapseExample_${uuid}_strokwidith`}>
            <div
              className='item-config-align-title'
            
            >
              Tamanho da borda
            </div>
            {/* <label className='switch pull-right'>
              <input type='checkbox' id='text' name='text' />
              <span className='slider round'></span>
            </label> */}
          </div>
          <div
            className='border-left-layers w-100 collapse '
            id={`collapseExample_${uuid}_strokwidith`}
          >
            <div className=''>
            <input
                        className='form-control'
                        type='text'
                        value={sizeBorder}
                        
                        onChange={(changeEvent) => {
                          let val = changeEvent.target.value
                          setSizeBorder( parseInt(val) );
                          onChange(val)
                        }}
                      />
              <RangeSlider
                        value={sizeBorder}
                        onChange={(changeEvent) => {
                            let val = changeEvent.target.value
                            setSizeBorder( parseInt(val) );
                            onChange(val)
                          }
                        }
                        min={0}
                        max={20}
                        step={1}
                      />
                     
                      
             
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
